// src/services/api/config.ts - ПОЛНАЯ ВЕРСИЯ с QR-кодами и новыми методами
import { apiClient } from './index';
import { ApiResponse, MenuItem, MenuCategory, QRCodeStats } from '@/types';

export const configApi = {
  // ========== КАТЕГОРИИ ==========
  getCategories: () =>
    apiClient.get<ApiResponse<MenuCategory[]>>('/api/admin/config/categories/'),

  createCategory: (data: Partial<MenuCategory>) =>
    apiClient.post<ApiResponse<MenuCategory>>('/api/admin/config/categories/create/', data),

  getCategory: (categoryId: number) =>
    apiClient.get<ApiResponse<MenuCategory>>(`/api/admin/config/categories/${categoryId}/`),

  updateCategory: (categoryId: number, data: Partial<MenuCategory>) =>
    apiClient.put<ApiResponse<MenuCategory>>(`/api/admin/config/categories/${categoryId}/update/`, data),

  deleteCategory: (categoryId: number) =>
    apiClient.delete<ApiResponse<{}>>(`/api/admin/config/categories/${categoryId}/delete/`),

  // ========== БЛЮДА ==========
  getMenuItems: (params?: {
    page?: number;
    per_page?: number;    
    category_ids?: number[];   // Множественный выбор
    status?: string;
    search?: string;
  }) =>
    apiClient.get<ApiResponse<{
      items: MenuItem[];
      pagination: {
        total: number;
        page: number;
        per_page: number;
        has_next: boolean;
        has_prev: boolean;
      };
    }>>('/api/admin/config/items/', { params }),

  createMenuItem: (data: FormData) =>
    apiClient.post<ApiResponse<MenuItem>>('/api/admin/config/items/create/', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  getMenuItem: (itemId: number) =>
    apiClient.get<ApiResponse<{
      item: MenuItem;
      additional_info: {
        stock_status: {
          current_stock: number;
          stock_available: number;
          is_available_for_order: boolean;
        };
        has_discounts: boolean;
        current_price: number;
        qr_info: {
          has_qr_code: boolean;
          qr_code_url: string | null;
          qr_generated_at: string | null;
          detail_page_url: string;
        };
        language_completeness: {
          ru: {
            name: boolean;
            description: boolean;
            composition: boolean;
            recipe: boolean;
            storage_instructions: boolean;
            cooking_instructions: boolean;
          };
          kz: {
            name: boolean;
            description: boolean;
            composition: boolean;
            recipe: boolean;
            storage_instructions: boolean;
            cooking_instructions: boolean;
          };
          en: {
            name: boolean;
            description: boolean;
            composition: boolean;
            recipe: boolean;
            storage_instructions: boolean;
            cooking_instructions: boolean;
          };
        };
      };
    }>>(`/api/admin/config/items/${itemId}/`),

  // Для JSON (без изображений)
  updateMenuItemData: (itemId: number, data: any) =>
    apiClient.patch<ApiResponse<MenuItem>>(`/api/admin/config/items/${itemId}/update/`, data),  

  // Для FormData (с изображениями)  
  updateMenuItem: (itemId: number, data: FormData) =>
    apiClient.patch<ApiResponse<MenuItem>>(`/api/admin/config/items/${itemId}/update/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  deleteMenuItem: (itemId: number) =>
    apiClient.delete<ApiResponse<{}>>(`/api/admin/config/items/${itemId}/delete/`),

  // ========== СКИДКИ ==========
  createDiscount: (itemId: number, discountPercent: number) =>
    apiClient.post<ApiResponse<{
      discount_id: number;
      discount_percent: number;
      original_price: number;
      discounted_price: number;
    }>>(`/api/admin/config/items/${itemId}/discount/create/`, {
      discount_percent: discountPercent
    }),

  removeDiscount: (itemId: number) =>
    apiClient.delete<ApiResponse<{}>>(`/api/admin/config/items/${itemId}/discount/remove/`),

  // ========== QR-КОДЫ ==========
  generateQrCode: (itemId: number) =>
    apiClient.post<ApiResponse<{
      qr_code_url: string;
      qr_generated_at: string;
      detail_url: string;
    }>>(`/api/admin/config/items/${itemId}/qr/generate/`),

  removeQrCode: (itemId: number) =>
    apiClient.delete<ApiResponse<{}>>(`/api/admin/config/items/${itemId}/qr/remove/`),

  bulkGenerateQrCodes: (itemIds: number[]) =>
    apiClient.post<ApiResponse<{
      total_processed: number;
      success_count: number;
      failed_count: number;
      failed_items: Array<{
        id: number;
        name: string;
        reason: string;
      }>;
    }>>('/api/admin/config/qr/bulk-generate/', { 
      item_ids: itemIds 
    }),

  getQrCodeStats: () =>
    apiClient.get<ApiResponse<QRCodeStats>>('/api/admin/config/qr/stats/'),

  bulkDownloadQrCodes: (itemIds: number[]) =>
    apiClient.post<any>('/api/admin/config/qr/bulk-download/', {
      item_ids: itemIds, // Передаем список ID выбранных блюд
    }, {
      responseType: 'blob', // !!! Важно: указываем Axios, что ожидаем двоичный файл (ZIP-архив)
    }),

  // ========== СТАТИСТИКА ==========
  getConfigStats: () =>
    apiClient.get<ApiResponse<{
      categories: {
        total: number;
        active: number;
        inactive: number;
      };
      items: {
        total: number;
        active: number;
        discontinued: number;
        with_discounts: number;
      };
    }>>('/api/admin/config/stats/'),
};